import { Template } from "@zapier/templates";

export const isZapTemplate = (template: Template) => {
  return (
    template.products?.length === 1 && template.products[0].slug === "zaps"
  );
};
